import { useSearchParams } from "next/navigation";
import type { Dispatch, ReactNode, RefObject, SetStateAction } from "react";
import { createContext, useMemo, useRef, useState } from "react";

export type SearchContextProps = {
  locale?: string;
  formRef?: RefObject<HTMLFormElement | null>;
  inputRef?: RefObject<HTMLInputElement | null>;
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
};

export const SearchContext = createContext<SearchContextProps>({
  value: "",
  setValue: () => {},
});

export type SearchProviderProps = {
  children: ReactNode;
  locale?: string;
};

export const SearchProvider = ({
  children,
  locale
}: SearchProviderProps) => {
  const params = useSearchParams();
  const formRef = useRef<HTMLFormElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState(params.get("query") ?? "");

  const context = useMemo(
    () => ({
      locale,
      formRef,
      inputRef,
      value,
      setValue,
    }),
    [locale, inputRef, value, setValue],
  );

  return (
    <SearchContext.Provider value={context}>{children}</SearchContext.Provider>
  );
};
